import FlexRow from "@/components/FlexRow.vue";
import { WrapWithSectionItem } from "../sections";
import RegionValue from "./RegionValue.vue";
import { TextValue } from "@/components/tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import FlexColumn from "../../FlexColumn.vue";
import WrapWithCopy from "@/components/WrapWithCopy.vue";
export default {
  name: "SellerFilterItem",
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue,
    FlexRow,
    FlexColumn,
    RegionValue,
    WrapWithCopy
  },
  emits: ["select", "selectOnly", "deselect"],
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    region: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
    no_reset: {
      type: Boolean,
      default: false
    },
    // Search term to highlight within the seller name.
    query: {
      type: String,
      default: ""
    }
  }
};